import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=2fc0b98f"
import script from "./uploadData.vue?vue&type=script&lang=js"
export * from "./uploadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports